import { Controller } from "@hotwired/stimulus"

// facilities--confirm-then-open — a warning dialog that, once confirmed, opens
// another dialog: the leg screen's Replace RackEye asks first and only then
// shows the device code dialog (CONEK-8910). Cancel, the X, Escape and the
// backdrop close the warning and open nothing.
//
// Wraps the warning's <dialog> (a Ui::AlertModalComponent). Its Continue button
// calls `proceed`, which closes the warning and opens the next dialog once the
// warning has finished closing (its `modal:close`). Opening the next one
// before that would put two modal dialogs in the top layer at once, and the
// warning's close would then hand focus back to the button under them and
// unlock the page's scroll while the second dialog is still showing.
//
// Values:
//   targetId  the id of the dialog to open after the warning (a
//             Ui::ModalComponent, wired to ui--modal)
export default class extends Controller {
  static values = { targetId: String }

  connect() {
    this.proceeding = false
  }

  // Never opens the code dialog without the warning having been shown and
  // closed: a missing warning is a wiring bug, said out loud, not a reason to
  // skip the confirmation. A second Continue while the warning is still
  // closing is ignored.
  proceed() {
    if (this.proceeding) return

    const warning = this.modalController(this.element.querySelector("dialog"))
    if (!warning) {
      console.error(
        "facilities--confirm-then-open: no ui--modal warning dialog inside the controller; not opening",
        this.targetIdValue,
      )
      return
    }

    this.proceeding = true
    warning.close()
  }

  // modal:close bubbles from the warning's dialog.
  closed() {
    if (!this.proceeding) return

    this.proceeding = false
    this.openTarget()
  }

  openTarget() {
    this.modalController(document.getElementById(this.targetIdValue))?.open()
  }

  modalController(element) {
    if (!element) return null

    return this.application.getControllerForElementAndIdentifier(
      element,
      "ui--modal",
    )
  }
}
